<script lang="ts">
    import { VpInformationIcon } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';

    export let totalAdults: number;
    export let totalChildren: number;
    export let showAdultsError: boolean;
</script>

<div class="flex items-center justify-between">
    <span class="text-sm font-semibold"
        >{trans('tour.aside_panel.travelgate.composition_title')}</span
    >
    <span class="text-xs"
        >{trans('tour.aside_panel.travelgate.total_pax', {
            '%adults%': String(totalAdults),
            '%children%': String(totalChildren),
        })}</span
    >
</div>
{#if showAdultsError}
    <div
        class="bg-commercial-negative text-content-negative flex items-center gap-xs gap-x-2 rounded-lg p-xs text-xs"
    >
        <span><VpInformationIcon size={12} /></span>
        <span>{trans('tour.aside_panel.at_least_2')}</span>
    </div>
{/if}
